import { StyleSheet } from 'react-native-unistyles';

import { theme } from '@squire/ui';

export const styles = StyleSheet.create((colors, rt) => ({
  dialog: {
    flex: 1,
  },
  footer: {
    backgroundColor: colors.backgroundL0,
  },
  footerFade: {
    position: 'absolute',
    top: -theme.spacing[5],
    left: 0,
    right: 0,
    height: theme.spacing[5],
    pointerEvents: 'none',
  },
  maxWidthWrapper: {
    maxWidth: {
      default: undefined,
      tablet: theme.breakpoints.tablet,
    },
    left: {
      default: 0,
      tablet: '50%',
    },
    transform: [
      {
        translateX: {
          default: 0,
          tablet: '-50%',
        },
      },
    ],
  },
  background: {
    backgroundColor: colors.backgroundL0,
  },

  scrollContent: {
    backgroundColor: colors.backgroundL0,
    paddingBottom: rt.insets.bottom,
  },
  content: {
    backgroundColor: colors.backgroundL0,
  },

  backdrop: {
    backgroundColor: colors.overlayPrimary,
  },
  boxBackdrop: {
    backgroundColor: colors.overlayPrimary,
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    flex: 1,
  },
  topRounded: {
    borderTopLeftRadius: theme.borderRadius.s,
    borderTopRightRadius: theme.borderRadius.s,
    overflow: 'hidden',
  },
  handleContainer: {
    paddingVertical: theme.spacing[4],
    backgroundColor: colors.backgroundL0,
    alignItems: 'center',
    justifyContent: 'center',
  },
  handleIndicator: {
    height: 4,
    width: 40,
    backgroundColor: colors.backgroundL1,
    borderRadius: theme.borderRadius.full,
  },
}));
